import { Form as BaseForm } from '@aibees/shared/components';
import { Paper as BasePaper, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  border: 1px solid ${(props) => props.theme.palette.grey[200]};
  border-radius: ${(p) => p.theme.spacing(1)};
`;

export const Form = styled(BaseForm)``;

export const Paper = styled(BasePaper)`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing(3)};
`;
